export const unwrapApiData = <T>(response: unknown): T => {
  const maybeObject = response as { data?: unknown };

  if (
    maybeObject
    && typeof maybeObject === 'object'
    && Object.prototype.hasOwnProperty.call(maybeObject, 'data')
  ) {
    return maybeObject.data as T;
  }

  return response as T;
};
